import { BaseFieldRenderer } from './base-field-renderer';
import { SubscribeFieldJsonData, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class SubscribeFieldRenderer extends BaseFieldRenderer<SubscribeFieldJsonData> {
    protected override get defaultData(): SubscribeFieldJsonData {
        return {
            id: '',
            type: 'subscribe',
            label: TranslateUtils.SUBSCRIBE_FIELD.LABEL,
            required: false,
            hiddenLabel: false,
            crmFieldData: {
                mixedType: 'ContactField',
                type: 'Boolean',
                systemName: 'Subscribe',
                name: 'Subscribe'
            }
        };
    }

    protected override renderContent(fieldJsonData: SubscribeFieldJsonData, options: RenderOptions = {}): HTMLElement {
        const elementContent = document.createElement('div');
        elementContent.classList.add('element-content');

        const fieldContainer = document.createElement('div');
        fieldContainer.classList.add('field', 'checkbox');
        fieldContainer.classList.toggle('required', fieldJsonData.required === true);

        const optionsContainer = document.createElement('div');
        optionsContainer.classList.add('options');

        const inputContainer = document.createElement('div');
        inputContainer.classList.add('input-container', 'option');

        const input = this.renderInput(fieldJsonData, options);
        inputContainer.appendChild(input);

        if (!fieldJsonData.hiddenLabel) {
            const label = this.renderLabel(fieldJsonData);
            inputContainer.appendChild(label);
        }

        optionsContainer.appendChild(inputContainer);

        fieldContainer.appendChild(optionsContainer);

        const errorContainer = this.renderErrorContainer(fieldJsonData);
        fieldContainer.appendChild(errorContainer);

        if (fieldJsonData.showDescription) {
            const description = this.renderDescription(fieldJsonData);
            fieldContainer.appendChild(description);
        }

        elementContent.appendChild(fieldContainer);

        return elementContent;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderInput(fieldJsonData: SubscribeFieldJsonData, options: RenderOptions): HTMLElement {
        const input = document.createElement('input');
        input.classList.add('input');
        input.type = 'checkbox';
        input.value = 'true';
        input.checked = fieldJsonData.defaultValue ?? false;

        this.applyCommonAttributes(input, fieldJsonData);

        return input;
    }
}
